
import { defineComponent, onMounted, ref } from 'vue';
import { useClipboard } from '@vueuse/core';
// eslint-disable-next-line import/no-cycle
import UserService from '@/services/UserService';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  setup() {
    const dataLoading = ref(true);
    const { text, copy, copied } = useClipboard();

    const apiKey = ref('');

    function regenerate() {
      dataLoading.value = true;
      UserService.regeneratePApiToken().then((response) => {
        localStorage.setItem('P_API_TOKEN', response.results.apiKey);
        apiKey.value = response.results.apiKey;
        dataLoading.value = false;
      }).finally(() => { dataLoading.value = false; });
    }

    onMounted(() => {
      apiKey.value = localStorage.getItem('P_API_TOKEN') || '';
      if (!apiKey.value) {
        // retrieve key
        UserService.getPApiToken().then((response) => {
          localStorage.setItem('P_API_TOKEN', response.results.apiKey);
          dataLoading.value = false;
        }).finally(() => { dataLoading.value = false; });
      } else {
        dataLoading.value = false;
      }
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      dataLoading,
      apiKey,
      text,
      copy,
      copied,
      regenerate,
    };
  },
});
